import React from 'react';
import { alignSingleBarLeft, hideBarPadLabel, CHART_PALETTE, CHART_TITLE_STYLE } from "../HelperFunction/helperFunction";
import Chart from "react-apexcharts";
import ExceptionVariables from '../JSON Files/ExceptionVariables.json'
import { useOutletContext } from 'react-router-dom';

function SingleBarChart7({ fulldataset, type, isValue, range, maxValuedynamicVolume }) {
  const { theme } = useOutletContext();
  const isDark = theme !== 'light';
  const isStacked = fulldataset?.plot12?.some(item => item.frequency);
  let maxValue = isStacked?3*maxValuedynamicVolume:maxValuedynamicVolume;
  let hidevar=ExceptionVariables.hiddenroichart;
  let filtered_data = fulldataset?.plot12.filter((it)=> it.attribute_value_per_roi > 0 )
  const filtered = filtered_data?.filter(varObj => !hidevar?.includes(varObj?.variable) )
  
  // Check if frequency exists in the dataset to determine stacking

  // Transform data for stacked chart if frequency exists
  let categories = [];
  let series = [];

  if (isStacked) {
    let groupedData = {};

    filtered?.forEach(item => {
      if (!groupedData[item.variable]) {
        groupedData[item.variable] = {};
      }
      groupedData[item.variable][item.frequency] = 
        Number(item.attribute_value_per_roi?.toFixed(3)) || 0;
    });

    categories = [...new Set(filtered?.map(item => item.frequency))];
    const variableTypes = Object.keys(groupedData);
    
    series = variableTypes.map(variable => ({
      name: variable,
      data: categories.map(freq => groupedData[variable][freq] || 0),
    }));
  } else {
    // Non-stacked chart
    categories = filtered?.map(item => item.variable);
    series = [{
      name: "ROI",
      data: filtered?.map(it => Number(it?.attribute_value_per_roi?.toFixed(3)) || 0),
    }];
  }

  ({ categories, series } = alignSingleBarLeft(categories, series));
  const barColumnWidth = `${Math.min(70, Math.max(categories?.length || 1, 1) * 11)}%`;

  const options = {
    chart: {
      id: `Download-ROI for Incremental Variables`,
      type: "bar",
      stacked: isStacked,
      toolbar: { show: true },
      background: 'transparent',
    },
    grid: { show: false },
    tooltip: {
      theme: isDark ? 'dark' : 'light',
    },
    title: {
      text: `ROI for Incremental Variables (${type})`,
      align: 'center',
      style: CHART_TITLE_STYLE,
    },
    colors: CHART_PALETTE,
    plotOptions: {
      bar: { columnWidth: barColumnWidth, dataLabels: { position: "top" } },
    },
    dataLabels: {
      enabled: isStacked?false:true,
      offsetY: -15,
      style: { fontFamily: "'JetBrains Mono', 'Inter', monospace", fontSize: "12px", fontWeight: 600 },
      formatter: (val) => (val == null ? "" : Number(val).toFixed(3)),
    },
    xaxis: {
      categories,
      title: { text: '', style: { fontWeight: 600, fontSize: "12px" } },
      labels: {
        rotate: -35,
        rotateAlways: true,
        formatter: (val) => hideBarPadLabel(val),
        style: { fontWeight: 500, fontSize: "11px" },
      },
    },
    yaxis: {
      opposite: false,
      axisBorder: { show: true },
      labels: {
        style: { fontWeight: 500, fontSize: "11px" },
        formatter: (val) => {
          const num = Number(val);
          if (!Number.isFinite(num)) return "";
          return maxValue >= 10 ? num.toFixed(0) : num.toFixed(2);
        },
      },
      min: 0,
      max: Math.ceil(maxValue),
    },
    annotations: {
      yaxis: [{
        y: 0,
        borderColor: '#6C757D',
        label: {
          text: '',
          style: { color: '#6C757D', background: '#1A252F' },
        },
      }],
    },
    legend: { show: isStacked, fontSize: "12px" },
  };

  return (
    <>
      <div className="rr-chart-period">
        <small>Time Period: {range}</small>
      </div>
      <div className="rr-chart-yaxis">
        <span className="rr-chart-yaxis-label">ROI</span>
        <div className="rr-chart-yaxis-body">
          <Chart className="rr-apex rr-apex-bar"
            align="center"
            options={options}
            series={series}
            type="bar"
            height={320}
            width={'100%'}
          />
        </div>
      </div>
    </>
  );
}

export default SingleBarChart7;
